import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreLink } from "@slhuicore/link";
import { style } from "./assets/link.generated-style";

/**
 * Link component
 *
 * @CustomElement slh-link
 * @cssprop --slh-default-font-family - Font family.
 * @cssprop --slh-base-m-font-size - Font size.
 * @cssprop --slh-base-semi-bold-font-weight - Font weight.
 * @cssprop --slh-base-xxs-line-height - Line height.
 * @cssprop --slh-color-neutral - Primary / default link hover / focus font color. Primary focus color. Secondary link hover / focus font color. Tertiary link hover / focus font color. Ghost link hover / focus font color. Negative link font color.
 * @cssprop --slh-color-neutral-shade-00 - Ghost link normal / focus background color.
 * @cssprop --slh-color-neutral-shade-10 - Ghost link hover background color.
 * @cssprop --slh-color-neutral-shade-20 - Secondary link background color. Disabled link background / border color.
 * @cssprop --slh-color-neutral-shade-40 - Ghost link outline color. Disabled link font color.
 * @cssprop --slh-color-neutral-shade-80 - Primary / default link font color. Secondary link font color. Tertiary link font color. Ghost link font color.
 * @cssprop --slh-color-neutral-shade-80-opacity-18 - Primary / secondary / ghost / negative link focus shadow color.
 * @cssprop --slh-color-primary-darken - Tertiary / default link hover / focus text underline color.
 * @cssprop --slh-color-primary-shade-40 - Primary link background color.
 * @cssprop --slh-color-primary-shade-60 - Primary link hover / focus background color. Primary link border color.
 * @cssprop --slh-color-error-shade-60 - Negative link background color.
 * @cssprop --slh-color-error-shade-80 - Negative link hover / focus background color.
 *
 * ** slots
 * @slot default - Link label
 * @slot icon-left - Custom content on the left side of the link label.
 * @slot icon-right - Custom content on the right side of the link label.
 */
@customElement("slh-link")
export default class SlhLink extends SlhCoreLink(LitElement) {
  static styles = style;
}
